import { render, staticRenderFns } from "./task-card.vue?vue&type=template&id=3ff20ea8&scoped=true&"
import script from "./task-card.vue?vue&type=script&lang=ts&"
export * from "./task-card.vue?vue&type=script&lang=ts&"
import style0 from "./task-card.vue?vue&type=style&index=0&id=3ff20ea8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff20ea8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
